/**
 * Centralized post-login navigation logic
 * Ensures consistent behavior across all auth methods (Email/Phone, Google OAuth)
 */

import { NavigateFunction } from 'react-router-dom';
import { AuthUser } from '../services/auth.api';
import { ROUTES } from '../config/routes';

interface NavigateAfterAuthParams {
  user: AuthUser;
  isNewUser?: boolean;
  navigate: NavigateFunction;
  /** Optional post-auth redirect path (e.g. /invite/accept?token=...) */
  redirectTo?: string | null;
}

/**
 * Determines where to navigate after successful authentication
 *
 * Flow:
 * - If redirectTo is supplied (e.g. from invite link), navigate there.
 * - If user has not completed onboarding, navigate to /onboarding.
 * - Otherwise navigate to /dashboard.
 */
export function navigateAfterAuth({ user, isNewUser: _isNewUser, navigate, redirectTo }: NavigateAfterAuthParams) {
  if (redirectTo) {
    navigate(redirectTo, { replace: true });
    return;
  }

  if (!user.onboardingComplete) {
    navigate(ROUTES.ONBOARDING, { replace: true });
    return;
  }

  navigate(ROUTES.DASHBOARD, { replace: true });
}
